<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <ng-container *ngIf="jobData.length > 0; else showMessage">
    <div class="applications-page">
      <button class="back-btn" (click)="goToJobDashboard()">
        <i class="bi bi-arrow-left"></i>
        Back
      </button>

      <div class="page-header">
        <h1 class="title">My Applications ({{ total }})</h1>
        <p class="subtitle">
          Track every stage of your placement journey
        </p>
      </div>

      <div class="application-card mb-4" *ngFor="let application of jobData">
        <div class="card-top">
          <div class="company-section">
            <div class="company-logo">
              <img *ngIf="application.company_logo" [src]="application.company_logo" alt="Company Logo"
                class="img-fluid logo" />
              <i *ngIf="!application.company_logo" class="bi bi-briefcase"></i>
            </div>

            <div>
              <p class="company-name">
                {{ application.company_name }}
              </p>

              <h2 class="job-role">
                {{ application.job_title }}
              </h2>

              <p class="applied-date">
                Applied
                {{ application.applied_at | date: "mediumDate" }}
              </p>
            </div>
          </div>

          <!-- Action Buttons -->

          <ng-container *ngIf="showAssessmentButton(application)">
            <button class="action-btn" (click)="openAssessment(application)">
              Start Assessment
            </button>
          </ng-container>

          <ng-container *ngIf="showInterviewButton(application)">
            <button class="action-btn" (click)="openInterview(application)">
              Start Interview
            </button>
          </ng-container>

          <ng-container *ngIf="application.status === 'shortlisted'">
            <div class="status-badge shortlisted">
              <i class="bi bi-patch-check-fill"></i>
              Shortlisted
            </div>
          </ng-container>

          <ng-container *ngIf="application.status === 'shortlisted'">
            <div class="status-badge shortlisted">
              <i class="bi bi-patch-check-fill"></i>
              Shortlisted
            </div>
          </ng-container>
        </div>

        <div class="timeline">
          <div class="step completed">
            <div class="step-circle">
              <i class="bi bi-check"></i>
            </div>

            <h4>Applied</h4>
            <p>Submitted</p>
          </div>

          <ng-container *ngIf="showAssessment(application)">
            <div class="line"></div>

            <div class="step" [ngClass]="{
                completed: application.assessment.completed_at,
                active:
                  application.assessment.status === 'pending' &&
                  !application.assessment.completed_at,
              }">
              <div class="step-circle">
                <i class="bi" [ngClass]="{
                    'bi-check': application.assessment.completed_at,
                    'bi-clock': !application.assessment.completed_at,
                  }"></i>
              </div>

              <h4>Assessment</h4>

              <p>
                {{
                application.assessment.completed_at ? "Completed" : "Pending"
                }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="showInterview(application)">
            <div class="line"></div>

            <div class="step" [ngClass]="{
                completed: application.interview.completed_at,

                active:
                  application.interview.status === 'pending' &&
                  (application.assessment.status === 'not_assigned' ||
                    application.assessment.completed_at),

                locked:
                  application.interview.status === 'pending' &&
                  application.assessment.status !== 'not_assigned' &&
                  !application.assessment.completed_at,
              }">
              <div class="step-circle">
                <i class="bi" [ngClass]="{
                    'bi-check': application.interview.completed_at,
                    'bi-clock':
                      application.interview.status === 'pending' &&
                      (application.assessment.status === 'not_assigned' ||
                        application.assessment.completed_at),
                    'bi-lock':
                      application.interview.status === 'pending' &&
                      application.assessment.status !== 'not_assigned' &&
                      !application.assessment.completed_at,
                  }"></i>
              </div>

              <h4>Interview</h4>

              <p>
                {{
                application.interview.completed_at
                ? "Completed"
                : application.assessment.status !== "not_assigned" &&
                !application.assessment.completed_at
                ? "Waiting for Assessment"
                : "Pending"
                }}
              </p>
            </div>
          </ng-container>

          <div class="line"></div>

          <div class="step" [ngClass]="{
              completed: application.status === 'selected' || isAllStepsCompleted(application),
              active: application.status === 'shortlisted' && !isAllStepsCompleted(application),
              locked:
                (application.status === 'applied' ||
                application.status === 'in_progress') && !isAllStepsCompleted(application),
            }">
            <div class="step-circle">
              <i class="bi" [ngClass]="{
                  'bi-check': application.status === 'selected',
                  'bi-clock': application.status === 'shortlisted' || isAllStepsCompleted(application),
                  'bi-lock':
                    (application.status === 'applied' ||
                    application.status === 'in_progress') && !isAllStepsCompleted(application),
                }"></i>
            </div>

            <h4>Result</h4>

            <p>{{ (isAllStepsCompleted(application) && application.status !== 'selected' && application.status !==
              'shortlisted') ? 'Thank you for applying' : (application.status | titlecase) }}</p>
          </div>
        </div>

        <ng-container *ngIf="application.status === 'shortlisted'">
          <div class="short mt-4">
            You have been shortlisted for
            {{ application.job_title }}
            at
            {{ application.company_name }}. The recruiter will contact you
            shortly.
          </div>
        </ng-container>

        <ng-container
          *ngIf="isAllStepsCompleted(application) && application.status !== 'shortlisted' && application.status !== 'selected'">
          <div class="message-box mt-4">
            <div class="message-title">
              <i class="bi bi-envelope"></i> Thank you for applying!
            </div>
            <p>Your application will be reviewed, and the result will be shared with you via email <strong>within 2 business
              days</strong>. If you're shortlisted, our hiring team will get in touch with you.</p>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="text-center mb-3 font-name" *ngIf="page < totalPages">
      <button class="btn-add" (click)="loadMore()" [disabled]="isLoading">
        <ng-container *ngIf="isLoading; else showBtnText">
          <span class="spinner-border spinner-border-sm"></span> Loading...
        </ng-container>
        <ng-template #showBtnText>Load More</ng-template>
      </button>
    </div>
  </ng-container>

  <ng-template #showMessage>
    <div class="empty-state-wrapper">
      <div class="empty-icon-container">
        <i class="bi bi-send-x"></i>
      </div>
      <h3 class="font-name empty-title">No Applications Found</h3>
      <p class="empty-subtitle">You haven't applied to any jobs yet. Start exploring and applying to find your next opportunity!</p>
      <button class="action-btn empty-action-btn" (click)="goToJobDashboard()">Explore Jobs</button>
    </div>
  </ng-template>
</ng-template>